/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */

import React, { useState, useEffect } from 'react';
import Pagination from 'react-sanity-pagination';

import { sanityClient, PortableText, urlFor } from '../../lib/sanity';

import styles from '../../styles/Home.module.scss';

import BlogBlock from '../../components/blog/BlogBlock';

import StandardLayout from '../../components/layouts/StandardLayout';

import WhiteBlueIllustration from '../../components/elements/WhiteBlueIllustration';

import IntroCopyBlock from '../../components/elements/IntroCopyBlock';
import GreenQuote from '../../components/GreenQuote';

const blogQuery = `
{"blogPageQuery" : *[_id=="ce413594-863e-4e9c-8237-6a737a93cb50"] {
  title,
  meta,
  introheading,
  pinkmessage,
  introcopy,
  pagequote,
  paragraphs,
  customblocks,
  headerimage,
},
  "postQuery" : *[_type=="post"] | order(date desc) {
    _id,
    title,
    slug,
    content,
    excerpt,
    coverImage,
    date,
    author
  },
  "companyInfoQuery" : *[_type=="company"] {
    overlaytitle,
    message,
    title,
    footer,
    sociallinks,
    email,
    numbers
},
  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    linkaddress,
    "manuscriptURL": manuscript.asset->url,
    mapimage
  }
}`;

var PostItemsToSend = [];

export default function BlogList({ blogPageQuery, postQuery, companyInfoQuery, nurseryQuery }) {
  const PageInfo = blogPageQuery[0];
  const Company = companyInfoQuery;
  const Nurseries = nurseryQuery;
  const PageQuote = PageInfo.pagequote;

  // Create a variable for the amount of posts you want per page
  const postsPerPage = 9;
  // Create state which will be updated every time you paginate
  const [PostItems, setPostItems] = useState([]);

  const postPag = postQuery;

  // Fetch your all data initially
  useEffect(() => {
    // Push your data to the static array
    PostItemsToSend.splice(0, PostItemsToSend.length), PostItemsToSend.push(...postPag);
  }, [postPag]);

  // Create an action which will be called on paginate
  // This will return the current Page, Range of PostItems and the PostItems to render
  const action = (page, range, PostItems) => {
    // Update State
    setPostItems(PostItems);
  };

  return (
    <>
      <StandardLayout CompanyInfo={Company} Nurseries={Nurseries} PageInfo={PageInfo} headerWidth={1920} headerHeight={600} headerMinHeight={300} hideLeadImage={false}>
        <div className={styles.mainContent}>
          <div className="container">
            <IntroCopyBlock PageInfo={PageInfo} />

            <div className="spacer"></div>

            <BlogBlock Posts={PostItems} />
          </div>
        </div>

        <Pagination nextButton={true} prevButton={true} jumpStartButton={true} jumpEndButton={true} items={PostItemsToSend} action={action} postsPerPage={postsPerPage} paginationStyle={'default'} />
        {PageQuote && <GreenQuote quote={PageQuote} />}
        <WhiteBlueIllustration />
      </StandardLayout>
    </>
  );
}

export async function getStaticProps() {
  const { blogPageQuery, postQuery, companyInfoQuery, nurseryQuery } = await sanityClient.fetch(blogQuery);
  return { props: { blogPageQuery, postQuery, companyInfoQuery, nurseryQuery } };
}

/* <Paraloop CopyLoop={pageInfo.paragraphs} /> */
